/* True Nutra bundle picker - selection shim.
 *
 * WHY THIS EXISTS
 * The bundle widget on this page is markup captured from truenutrawellness.com
 * after their Kaching app had already rendered it. The markup is complete and
 * correct, and the stylesheet that dresses it was ported too - but the Vue app
 * that moved the "selected" state between bars did not come across. So the tiers
 * and checkboxes render, and nothing responds to a click.
 *
 * This restores the interaction using the app's OWN class vocabulary, verified
 * against the stylesheet actually loaded on the page:
 *
 *   .kaching-bundles__bar--selected .kaching-bundles__bar-container   bar highlight
 *   .kaching-bundles__bar--selected .kaching-bundles__bar-radio       radio dot fill
 *   .kaching-bundles__upsell__checkbox--selected                      upsell tick
 *   .kaching-bundles__checkbox-upsells__checkbox--selected            cross-sell tick
 *
 * Because it toggles the same classes the app would, nothing about the design,
 * spacing or copy changes.
 *
 * EACH TIER IS A PRODUCT VARIANT.
 * snippets/tn-bundles renders every tier with data-variant-id: tier 1, 2, 3 read
 * product.variants[0], [1], [2], and their prices come from those variants. Picking
 * a tier puts that variant id in the product form, so the cart charges exactly the
 * price the tier shows. (Setting a quantity instead could not work: "llévate 1
 * GRATIS" needs Shopify to charge for fewer units than it ships.) The sticky bar's
 * price follows the chosen tier.
 *
 * SELF-DISABLING
 * If someone later configures a real offer in Kaching, the app ships a non-empty
 * deal-block-settings payload and takes over the widget itself. This shim detects
 * that and does nothing, so the two can never fight.
 */
(function () {
  'use strict';

  var BAR = '.kaching-bundles__bar[data-deal-bar-id]';
  var BAR_SELECTED = 'kaching-bundles__bar--selected';
  var UPSELL_BOX = '.kaching-bundles__upsell__checkbox';
  var UPSELL_BOX_SELECTED = 'kaching-bundles__upsell__checkbox--selected';
  var XSELL = '.kaching-bundles__checkbox-upsells__upsell';
  var XSELL_BOX = '.kaching-bundles__checkbox-upsells__checkbox';
  var XSELL_BOX_SELECTED = 'kaching-bundles__checkbox-upsells__checkbox--selected';

  // The app is live and managing the widget if it emitted a non-empty deal config.
  function appOwnsWidget() {
    var el = document.querySelector('script.kaching-bundles-deal-block-settings');
    if (!el) return false;
    var raw = (el.textContent || '').trim();
    if (!raw) return false;
    try {
      var cfg = JSON.parse(raw);
      return !!(cfg && Object.keys(cfg).length);
    } catch (e) {
      return false;   // unparseable means it is not driving anything
    }
  }

  // Put the tier's variant in the product form and mirror its price in the sticky bar.
  function syncVariant(bar) {
    var id = bar.getAttribute('data-variant-id');
    if (!id) return;
    var inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.closest('.product-form, product-form, [id^="product-form-"]')) input.value = id;
    });
    var price = bar.querySelector('.kaching-bundles__bar-price');
    var was = bar.querySelector('.kaching-bundles__bar-full-price');
    var sticky = document.querySelector('.sticky-atc__price .price');
    if (sticky && price) {
      var now = price.textContent.trim(), before = was ? was.textContent.trim() : '';
      Array.prototype.forEach.call(sticky.querySelectorAll('.price__regular .price-item--regular, .price-item--sale'),
        function (el) { el.textContent = now; });
      var s = sticky.querySelector('.price__compare-price .price-item--regular');
      if (s) s.textContent = before;
      sticky.classList.toggle('price--on-sale', !!before);
    }
    var title = bar.getAttribute('data-variant-title');
    var select = document.querySelector('.sticky-atc__variant-select');
    if (select && title && select.value !== title) select.value = title;
  }

  function selectBar(bar) {
    var scope = bar.closest('.kaching-bundles__bars') || document;
    var bars = scope.querySelectorAll(BAR);
    Array.prototype.forEach.call(bars, function (b) {
      b.classList.toggle(BAR_SELECTED, b === bar);
      var radio = b.querySelector('input[type="radio"]');
      if (radio) radio.checked = (b === bar);
    });
    syncVariant(bar);
  }

  /* The --selected class only repaints the BORDER. The tick itself is a child SVG
   * that Vue inserted, which is why the captured markup has empty <!----> slots
   * where it belongs and a checked box looked empty. These are the app's own
   * glyphs, lifted from its bundle; stroke="currentColor" picks up the box's
   * colour (--bar-selected-border-color), so they match the design exactly.
   * The 14x10 tick suits the 16px upsell box, the 16x16 the 20px cross-sell box. */
  var TICK_SMALL = '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" data-tn-tick="1" aria-hidden="true">' +
    '<path d="M12.334 1 5 8.333 1.667 5" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  var TICK_LARGE = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" ' +
    'xmlns="http://www.w3.org/2000/svg" data-tn-tick="1" aria-hidden="true">' +
    '<path d="M13.3307 4L5.9974 11.3333L2.66406 8" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function setTick(box, on, tick) {
    var existing = box.querySelector('[data-tn-tick]');
    if (on && !existing) box.insertAdjacentHTML('beforeend', tick);
    else if (!on && existing) existing.remove();
  }

  function toggleBox(box, selectedClass, tick) {
    var on = !box.classList.contains(selectedClass);
    box.classList.toggle(selectedClass, on);
    setTick(box, on, tick);
    // keep the accessible state in step with the visual one
    var role = box.closest('[role="checkbox"]') ||
               (box.getAttribute('role') === 'checkbox' ? box : null);
    if (role) role.setAttribute('aria-checked', on ? 'true' : 'false');
    return on;
  }

  function init() {
    if (appOwnsWidget()) return;

    /* Delegate from document, not from the widget element. The page carries more
     * than one .kaching-bundles container (the sticky bar has its own) and app
     * blocks re-render, so a listener bound to one node stops firing the moment
     * that node is replaced. Every handler below re-checks that the click landed
     * inside a bundles widget. */
    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.kaching-bundles')) return;
      // 1. a cross-sell row ("Complejo de Magnesio", "Complejo de Vitamina B")
      var xsell = event.target.closest(XSELL);
      if (xsell) {
        var xbox = xsell.querySelector(XSELL_BOX);
        if (xbox) toggleBox(xbox, XSELL_BOX_SELECTED, TICK_LARGE);
        return;
      }

      // 2. an upsell inside a tier ("llévate 2 paquetes GRATIS", "envío GRATIS").
      //    Checked before the tier so its click does not just re-select the bar.
      var upsell = event.target.closest('.kaching-bundles__upsell');
      if (upsell) {
        var ubox = upsell.querySelector(UPSELL_BOX);
        if (ubox) toggleBox(ubox, UPSELL_BOX_SELECTED, TICK_SMALL);
        event.preventDefault();
        return;
      }

      // 3. a bundle tier
      var bar = event.target.closest(BAR);
      if (bar) selectBar(bar);
    });

    // labels carry for=<radio>, so keyboard and native label activation still fire
    // a change event even though the input itself is display:none
    document.addEventListener('change', function (event) {
      var radio = event.target;
      if (radio && radio.type === 'radio' && radio.closest &&
          radio.closest('.kaching-bundles')) {
        var bar = radio.closest(BAR);
        if (bar) selectBar(bar);
      }
    });

    // keyboard support for the app's role=button / role=checkbox nodes
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!event.target.closest || !event.target.closest('.kaching-bundles')) return;
      var hit = event.target.closest('[role="button"], [role="checkbox"]');
      if (!hit) return;
      event.preventDefault();
      hit.click();
    });

    // the sticky bar's variant dropdown lists the same variants: keep the tiers in step
    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.classList || !select.classList.contains('sticky-atc__variant-select')) return;
      var bars = document.querySelectorAll(BAR + '[data-variant-title]');
      Array.prototype.forEach.call(bars, function (b) {
        if (b.getAttribute('data-variant-title') === select.value) selectBar(b);
      });
    });

    // the widget opens with a tier pre-selected ("El más popular hoy"); make the form
    // carry that tier's variant from the start, not the product's first variant
    var preselected = document.querySelector(BAR + '.' + BAR_SELECTED + '[data-variant-id]');
    if (preselected) syncVariant(preselected);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
